import { createAction } from 'redux-actions';
import { makeActionType } from '../utils';

const namespace = 'FEEDBACK';

export const sendFeedback = createAction(makeActionType(namespace, ['SEND']));
export const successFeedback = createAction(makeActionType(namespace, ['SUCCESS']));
